import { useDynamicViewSchema } from "../DynamicViewSchemaProvider/DynamicViewSchemaProvider";

import { WidgetDefinition } from "./Widget.typings";

export const useWidgetDefinition = <T = unknown>(
  widgetCode: string
): WidgetDefinition<T> | undefined => {
  const uiSchema = useDynamicViewSchema();
  const widgetDefinitions = uiSchema.widgetDefinitions;

  return widgetDefinitions.find((definition) => definition.code === widgetCode) as
    | WidgetDefinition<T>
    | undefined;
};
